"use client";

import React from "react";
import { Heading } from "@/components/ui/typography";
import Image from "next/image";

export default function CTA({ heading = "What the IRD Offshore Profits Exemption Application Actually Is" }: { heading?: string } = {}) {
  return (
    <section className="w-full px-4 min-[1340px]:px-0 md:py-[60px] py-[30px]">
      <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row gap-8">
        {/* LEFT IMAGE */}
       <div className="relative w-full h-[320px] lg:h-[482px] rounded-[16px] overflow-hidden">
  <Image
    src="/tax-frame.webp"
    alt="cta"
    fill
    className="object-cover"
  />
</div>

        {/* RIGHT CONTENT */}
        <div className="flex-1 flex flex-col gap-8">
          {/* TITLE */}
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-[16px] leading-[24px] text-white/70 font-medium">
              Creating a Hong Kong company does not automatically give you 0%
              tax. To formally confirm offshore treatment, your company submits
              an offshore profits tax exemption application to the Inland
              Revenue Department (IRD).
            </p>
          </div>

          {/* SECTION TITLE */}
         
          {/* CHECKLIST */}
          <div className="flex flex-col gap-[12px]">
             <p className="text-[12px] font-bold text-white/70">
            MuteTaxes prepares and submits this claim on your behalf. This
            includes:
          </p>

            {/* ROW 1 */}
            <div className="flex flex-col md:flex-row gap-5">
              <div className="flex gap-3 w-full items-start md:w-[270px]">
                <Image src="/list-check.svg" alt="" width={19} height={19} className="mt-1" />
                <p className="text-[16px] text-white/70">
                  Management location confirmation
                </p>
              </div>

              <div className="flex gap-3 w-full items-start md:w-[270px]">
                <Image src="/list-check.svg" alt="" width={19} height={19} className="mt-1"/>
                <p className="text-[16px] text-white/70">
                  Customer geography documentation
                </p>
              </div>
            </div>

            {/* ROW 2 */}
            <div className="flex flex-col items-start md:flex-row gap-5">
              <div className="flex gap-3 w-full md:w-[270px]">
                <Image src="/list-check.svg" alt="" width={19} height={19} className="mt-1"/>
                <p className="text-[16px] text-white/70">
                  Contract structure evidence
                </p>
              </div>

              <div className="flex gap-3 w-full items-start md:w-[270px]">
                <Image src="/list-check.svg" alt="" width={19} height={19} className="mt-1"/>
                <p className="text-[16px] text-white/70">
                  Operational flow description
                </p>
              </div>
            </div>

            {/* ROW 3 */}
            <div className="flex gap-3">
              <Image src="/list-check.svg" alt="" width={19} height={19} />
              <p className="text-[16px] text-white/70">
                Business activity explanation
              </p>
            </div>
          </div>

          {/* FOOT NOTE */}
          <p className="text-[12px] leading-[160%] text-white font-medium">
            The IRD then reviews whether profits qualify as offshore. Once
            accepted, your company’s offshore status becomes part of its
            official tax position. This is what separates a properly structured
            company from a basic incorporation service.
          </p>
        </div>
      </div>
    </section>
  );
}
